export default __webpack_public_path__ + "static/media/ate1.219b3adb.png";